const services = [
  {
    id: 'software',
    title: 'ソフトウェア開発',
    description:
      'システムの企画・設計から開発、保守運用まで。お客様のビジネス課題に寄り添った最適なソリューションを提供します。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20flowing%20digital%20code%20and%20data%20streams%20as%20ethereal%20light%20curtains%20in%20warm%20champagne%20tones%20against%20soft%20cosmic%20background%2C%20clean%20modern%20aesthetic%2C%20delicate%20feminine%20touch%2C%20fine%20art%20abstract%20photography%2C%20warm%20ivory%20and%20cream%20highlights&width=800&height=800&seq=rse-svc-software&orientation=squarish',
    icon: 'ri-code-s-slash-line',
  },
  {
    id: 'consulting',
    title: 'ITコンサルティング',
    description:
      '情報通信システムや情報処理システムに関する戦略立案から導入支援まで、技術の専門家が伴走します。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20luminous%20interconnected%20network%20nodes%20forming%20gentle%20light%20curtains%20floating%20in%20space%2C%20warm%20ivory%20and%20soft%20sage%20green%20tones%2C%20clean%20minimal%20aesthetic%20with%20scattered%20light%20particles%2C%20feminine%20futuristic%20technology%20concept%2C%20fine%20art%20abstract%20composition&width=800&height=800&seq=rse-svc-consulting&orientation=squarish',
    icon: 'ri-lightbulb-line',
  },
  {
    id: 'web',
    title: 'Web・デジタルコンテンツ',
    description:
      'Webサイトやアプリ、デジタルコンテンツの企画制作からデザイン、運営までをトータルにサポートします。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20flowing%20digital%20content%20waves%20and%20soft%20geometric%20shapes%20forming%20translucent%20light%20curtains%2C%20warm%20champagne%20and%20cream%20tones%2C%20scattered%20stardust%20particles%2C%20clean%20minimal%20feminine%20aesthetic%2C%20editorial%20fine%20art%20photography%20style%2C%20soft%20luminous%20glow&width=800&height=800&seq=rse-svc-web&orientation=squarish',
    icon: 'ri-window-line',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-[0.2em] mb-5">
            SERVICES
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 tracking-wide">
            事業内容
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] cursor-pointer"
            >
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm mb-4">
                  <i className={`${service.icon} text-white text-lg`}></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-light text-white mb-2 tracking-wide">
                  {service.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}